module.exports = __webpack_public_path__ + "img/mobile_biodiversity_festival_credit_deccan_development_society_2.f7b86723.jpg";